<template>
	<div>
		<a-row :gutter="10">
			<a-col :span="8">
				<a-card title="集中器查询">
					<div class="queryDiv">
						<a-input-search  placeholder="请输入集中器地址" :loading ="queryGprsLoading"
						 enter-button @search="queryGprs" style="width: 15rem;margin-right: 1.25rem;"/>
						 <span class="resultText">{{gprsResult}}</span>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8">
				<a-card title="表读数重置">
					<div class="queryDiv">
						<a-tooltip placement="right">
							<template slot="title">
								<span>将表的读数重置为0</span>
							</template>
							<a-input-search v-model="meterId" size="small"  style="width: 15rem;margin-right: 1.25rem;"  placeholder="请输入水表PID" enter-button="重置" @search="resetReadData"/>
						</a-tooltip>
						<span class="resultText">{{resetReadDataResult}}</span>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8">
				<a-card title="表状态修正">
					<div id="gprsQueryDiv">
						<a-tooltip placement="right">
							<template slot="title">
								<span>将表的状态修正为正常</span>
							</template>
							<div class="queryDiv">
								<a-textarea size="small"  v-model="statusMeterId" :rows="2" :autosize="true"  placeholder="多个表ID之间,用英文逗号分割"   style="margin-right: 0.5rem;padding: 8px;"/>
								<a-button :disabled="statusMeterId == null" size="small" type="primary" @click="fixMeterStatus" :loading="fixing">提交</a-button>
							</div>
						</a-tooltip>
						<span class="resultText">{{fixMeterStatusResult}}</span>
					</div>
				</a-card>
			</a-col>
		</a-row>
		<a-row :gutter="10" style="margin-top: 1.25rem;">
			<a-col :span="8">
				<a-card title="NB水表历史读数查询">
					<div class="queryDiv">
						<a-input v-model="nbMeterQueryModel.nbMeterAddr"  size="small"  placeholder="请输入NB水表地址"   style="width: 14rem;margin-right: 0.5rem;"/>
						<a-range-picker  format="YYYY-MM-DD" style="width: 15rem;margin-right: 0.5rem;" @change="onDateChange" size="small"/>
						<a-button size="small" type="primary" @click="queryNBMeter" :loading="nbMeterQueryModel.queryLoading">查询</a-button>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8">
				<a-card title="NB采集器一带多更新">
					<div class="queryDiv">
						<a-input v-model="oneMoreModel.collectorAddr"  size="small"  placeholder="请输入NB采集器地址"   style="width: 8rem;margin-right: 0.5rem;"/>
						<a-textarea size="small"  v-model="oneMoreModel.meterAddr" :rows="2" :autosize="true"  placeholder="多个表地址之间,用英文逗号分割"   style="margin-right: 0.5rem;padding: 8px;"/>
						<a-tooltip placement="top">
							<template slot="title">
								<span>将表的采集器地址更新为输入的采集器地址</span>
							</template>
							<a-button type="primary" size="small" @click="updateNBCollectorMeter()" :loading="oneMoreModel.submiting">更新</a-button>
						</a-tooltip>
						<a-tooltip placement="top">
							<template slot="title">
								<span>配置采集器的表信息</span>
							</template>
							<a-button size="small" type="primary" @click="configNBCollector()" style="margin-left: 0.5rem;">配置</a-button>
						</a-tooltip>
						<a-tooltip placement="top">
							<template slot="title">
								<span>删除采集器关联的表信息</span>
							</template>
							<a-button size="small" type="danger" @click="deleteNBCollector()" style="margin-left: 0.5rem;">删除</a-button>
						</a-tooltip>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8">
				<a-card title="客户楼号信息更新">
					<div class="queryDiv">
						<a-input-search v-model="customerId" size="small"  style="width: 15rem;margin-right: 1.25rem;"  placeholder="请输入支付宝缴费号" enter-button="查询" @search="queryCustomerInfo"/>
					</div>
				</a-card>
			</a-col>
		</a-row>
		<a-row :gutter="10" style="margin-top: 1.25rem;">
			<a-col :span="8">
				<a-card title="根据小区更新水表口径">
					<div class="queryDiv">
						<a-select  style="width:11rem; margin-right: 0.5rem;font-size: 0.75rem;" v-model="theNeighborId" placeholder="选择小区"
									    option-filter-prop="children"  :filter-option="filterOption" show-search>
							<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
						</a-select>
						<a-select v-model="meterKindId" style="width:11rem; font-size: 0.75rem;" placeholder="选择口径">
							<a-select-option v-for="(item,index) in meterKindList"  :value="item.PID" :key="item.PID">{{item.MeterTypeName}}</a-select-option>
						</a-select>
						<a-button size="small" type="primary" @click="updateMeterKind()" style="margin-left: 0.5rem;" :loading="updating">更新</a-button>
					</div>
				</a-card>
			</a-col>
			<a-col :span="16">
				<a-card title="人工核对支付宝账目">
					<div class="queryDiv">
						<a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload" :disabled="uploading"
										accept=".txt">
							<a-button type = "default" icon = "upload">选择文件 </a-button>
						</a-upload>
						 <a-date-picker placeholder="请选择核账日期" v-model="checkDate" allowClear style="width: 10rem;margin-left: 1.25rem;margin-right: 1.25rem;"/>
						<a-button icon="cloud-upload" type="primary" :loading="uploading" :disabled="fileList.length == 0"
							 @click="doSubmit">
							开始上传
						</a-button>
					</div>
				</a-card>
			</a-col>
		</a-row>
		<a-row :gutter="10" style="margin-top: 1.25rem;">
			<a-col :span="8">
				<a-card title="客户和水表信息互换">
					<div class="queryDiv">
						<a-select  style="width:11rem; margin-right: 0.5rem;font-size: 0.75rem;" v-model="neighborId4Customer" placeholder="选择小区"
									    option-filter-prop="children"  :filter-option="filterOption" show-search>
							<a-select-option v-for="(item,index) in neighborList" :key="item.pId" :value="item.pId">{{item.neighborName}}</a-select-option>
						</a-select>
						<a-input  ref="chosedCustomerInput" placeholder="选择要互换的客户" style="width: 14rem;margin-right: 0.5rem;"
										readOnly  size="small" @click="chooseCustomer"></a-input>
										<a-button type="primary" size="small" @click="adjustCustomer()" >提交</a-button>
					</div>
				</a-card>
			</a-col>
			<a-col :span="8">
				<a-card title="修改水表集中器信息">
					<div class="queryDiv">
						<a-input  placeholder="请输入集中器地址" style="width: 10rem;margin-right: 1.25rem;" v-model="myGprsAddr"/>
						<div class="queryDiv">
							<a-textarea size="small"  v-model="changeGprsMeterIds" :rows="4" :autosize="true"  placeholder="多个表ID之间,用英文逗号分割"   
									style="margin-right: 0.5rem;padding: 8px; width:15rem"/>
							<a-button :disabled="myGprsAddr == null && changeGprsMeterIds == null" size="small" type="primary" @click="changeGprsMeter" :loading="fixing">提交</a-button>
						</div>
					</div>
				</a-card>
			</a-col>
		</a-row>
		<ReadNBMeterHistory ref="nbMeterHistoryView"/>
		<ConfigNBCollectorMeterView ref="configCollectorMeterView"/>
		<AdjustCustomerMeterNew ref="adjustCustomerMeterView" @doCheckSelect="doCheckSelect"/>
		<a-modal title="客户楼号信息更新" :visible="customerUpdateFlag" @ok="updateCustomerInfo" @cancel="customerUpdateFlag = false"
					cancel-text="取消" ok-text="提交" :confirm-loading="submitFlag">
			<div class="queryDiv">
				<label>所属小区：{{customerInfo.NeighborName}}</label>
			</div>
			<div class="queryDiv">
				<label>客户姓名：{{customerInfo.CustomerName}}</label>
			</div>
			<div class="queryDiv">
				<label>楼单元号：</label>
				<a-input v-model="customerInfo.LouNum"  style="width:7rem;margin-right: 0.5rem;" @change="changeHandler"/>
				<a-input v-model="customerInfo.DYNum" style="width:7rem;margin-right: 0.5rem;" @change="changeHandler"/>
				<a-input v-model="customerInfo.HuNum" style="width:7rem;margin-right: 0.5rem;" @change="changeHandler"/>
			</div>
			<div class="queryDiv">
				<label>客户地址：{{customerInfo.CustomerAddr}}</label>
			</div>
		</a-modal>
		<a-modal title="以下账目信息不存在" :visible="showMissFlag" @ok="fixMissedPay" @cancel="showMissFlag = false"
					cancel-text="取消" ok-text="后台纠正">
					<vxe-table  align="center" :data="missedList"  border max-height="500"   size="mini"
									  resizable highlight-hover-row  row-id="customerId">
							<vxe-table-column type="seq" width="45"/>
							<vxe-table-column title="支付宝缴费号" field="customerId" ></vxe-table-column>
							<vxe-table-column title="缴费金额" field="amount" ></vxe-table-column>
							<vxe-table-column title="缴费流水号" field="orderNo"></vxe-table-column>
					</vxe-table>
		</a-modal>
	</div>
</template>

<script>
	import ReadNBMeterHistory from  '../components/ReadNBMeterHistory.vue'
	import ConfigNBCollectorMeterView from '../components/ConfigNBCollectorMeterView.vue'
	import AdjustCustomerMeterNew from '../components/AdjustCustomerMeterNew.vue'
	export default {
		components: {
			ReadNBMeterHistory,
			ConfigNBCollectorMeterView,
			AdjustCustomerMeterNew,
		},
		data() {
			return {
				fixing:false,
				showMissFlag:false,
				missedList:[],
				checkDate:null,
				fileList:[],
				uploading: false,
				updating:false,
				gprsResult:null,
				queryGprsLoading:false,
				meterId:null,
				statusMeterId:null,
				resetReadDataResult:null,
				fixMeterStatusResult:null,
				nbMeterQueryModel:{
					nbMeterAddr:'',
					dateStart:null,
					dateEnd:null,
					queryLoading:false,
					nbCollectorAddr:null,
				},
				oneMoreModel:{
					collectorAddr:null,
					meterAddr:null,
					submiting:false,
				},
				customerUpdateFlag:false,
				customerInfo:{},
				customerId:null,
				submitFlag:false,
				neighborList:[],
				theNeighborId:null,
				meterKindList:[],
				meterKindId:null,
				neighborId4Customer:null,
				chosedCustomers:[],
				myGprsAddr:null,
				changeGprsMeterIds:null,
			}
		},
		methods: {
			changeGprsMeter(){
				let url = this.Api.getLastUrl(this.Api.COMMON_UPDATE_GRPS_METER_URL);
				let param ={meterIds:this.changeGprsMeterIds,gprsAddr:this.myGprsAddr};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("处理成功");
						this.changeGprsMeterIds = null;
						this.myGprsAddr = null;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			doCheckSelect(param){
				this.chosedCustomers = param;
				this.$refs.chosedCustomerInput.value = param[0].customerNum+"<--->"+param[1].customerNum;
			},
			adjustCustomer(){
				let url = this.Api.getLastUrl(this.Api.COMMON_ADJUST_CUSTOMER_URL);
				let param = JSON.stringify(this.chosedCustomers);
				this.Api.fetchPostWithJson(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("处理成功");
						this.chosedCustomers = [];
						this.$refs.chosedCustomerInput.value = '';
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			chooseCustomer(){
				if(this.neighborId4Customer == null || this.neighborId4Customer == undefined  ){
					this.$message.error('请先选择小区');
					return;
				}
				this.$refs.adjustCustomerMeterView.showView(this.neighborId4Customer);
			},
			fixMissedPay(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_FIX_ALIPAY_URL);
				let param = JSON.stringify(this.missedList);
				this.Api.fetchPostWithJson(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("处理成功");
						this.showMissFlag = false;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			doSubmit(){
				let date = new Date(this.checkDate);
				let formatDate =  this.Config.formatDateShortly(date);
				
				this.uploading = true;
				const formData = new FormData();
				formData.append('file', this.fileList[0]);
				formData.append("checkDate",formatDate);
				let url = this.Api.getLastUrl(this.Api.COMMON_MENUAL_CHECK_URL);
				this.Api.fetchPostWithFiles(url,formData).then((data)=>{
					this.uploading = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						var flag  = result.flag;
						var content = result.msg;
						if(!flag){
							this.$message.info(content);
						}else{
							this.missedList = result.missedList;
							this.showMissFlag = true;
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.uploading = false;
					console.log(error);
				})
				
				
			},
			beforeUpload:function(file){
				let flag  = file.type === 'text/plain';
				if(flag){
					this.fileList = [];
					this.fileList = [...this.fileList, file];
				}else{
					this.$message.error('只能上传txt文件');
				}
				return false;
			},
			handleRemove:function(file){
				const index = this.fileList.indexOf(file);
				const newFileList = this.fileList.slice();
				newFileList.splice(index, 1);
				this.fileList = newFileList;
			},
			validUpdateMeterKind(){
				if(this.theNeighborId == null){
					this.$message.error('请选择小区');
					return false;
				}
				if(this.meterKindId == null){
					this.$message.error('请选择水表口径');
					return false;
				}
				return true;
			},
			updateMeterKind(){
				if(this.validUpdateMeterKind()){
					this.updating = true;
					let param = {
						neighborId:this.theNeighborId,
						meterKindId:this.meterKindId
					};
					let url = this.Api.getLastUrl(this.Api.COMMON_UPDATE_METER_KIND_URL);
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.updating = false;
						let code = data.data.code;
						let msg = data.data.message;
						let result = data.data.result;
						if(code == this.Api.HTTP_OK_CODE){
							this.$message.success('更新成功');
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.updating = false;
						console.log(error);
					});
				}
			},
			filterOption(input, option) {
				return (option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0);
			},
			changeHandler(){
				let a = this.customerInfo.NeighborName+this.customerInfo.LouNum+"号楼"+this.customerInfo.DYNum+"单元"+this.customerInfo.HuNum+"户";
				this.customerInfo.CustomerAddr = a;
			},
			queryCustomerInfo(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_ONE_GET_URL);
				let param = {
					customerId:this.customerId,
				};
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						if(result !=null){
							this.customerInfo = result;
							this.custom
							this.customerUpdateFlag = true;
						}
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			updateCustomerInfo(){
				this.submitFlag = true;
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_UPDATE_INFO_URL);
				this.Api.fetchPostWithForm(url,this.customerInfo).then((data)=>{
					this.submitFlag = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('更新成功');
						this.customerUpdateFlag = false;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.submitFlag = false;
					console.log(error);
				});
			},
			onDateChange(date, dateString) {
				this.nbMeterQueryModel.dateStart=dateString[0];
				this.nbMeterQueryModel.dateEnd=dateString[1];
			},
			queryNBMeter(){
				this.nbMeterQueryModel.queryLoading = true;
				let url = this.Api.getLastUrl(this.Api.QUERY_NBMETER_HISTORY_URL);
				this.Api.fetchPostWithForm(url,this.nbMeterQueryModel).then((data)=>{
					this.nbMeterQueryModel.queryLoading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$refs.nbMeterHistoryView.showView(result);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.nbMeterQueryModel.queryLoading = false;
					console.log(error);
				});
			},
			fixMeterStatus(){
				if(this.statusMeterId!=null && this.statusMeterId.length>0){
					this.fixing = true;
					let param = {meterIds:this.statusMeterId};
					let url = this.Api.getLastUrl(this.Api.METER_FIX_STATUS_URL);
					this.Api.fetchPostWithForm(url,param).then((data)=>{
						this.fixing = false;
						let code = data.data.code;
						let msg = data.data.message;
						let result = data.data.result;
						if(code == this.Api.HTTP_OK_CODE){
							this.fixMeterStatusResult = '更新成功';
						}else{
							this.$message.error(msg);
						}
					}).catch((error)=>{
						this.fixing = false;
						console.log(error);
					});
				}
			},
			resetReadData(){
				let param = {meterId:this.meterId};
				let url = this.Api.getLastUrl(this.Api.METER_RESET_READ_DATA_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.resetReadDataResult = msg;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryGprs(value) {
				this.queryGprsLoading = true;
				let param = {gprsAddr:value};
				let url = this.Api.getLastUrl(this.Api.QUERY_GPRS_RESULT_URL);
				this.Api.fetchPostWithForm(url,param).then((data)=>{
					this.queryGprsLoading = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.gprsResult = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.queryGprsLoading = false;
					console.log(error);
				});
			},
			updateNBCollectorMeter(){
				if(this.oneMoreModel.collectorAddr == null ||this.oneMoreModel.meterAddr == null){
					this.$message.error("请输入采集器地址和表地址");
					return ;
				}
				this.oneMoreModel.submiting = true;
				let url = this.Api.getLastUrl(this.Api.COMMON_QUERY_UPDATE_NBCOLLECTOR_METER_URL);
				this.Api.fetchPostWithForm(url,this.oneMoreModel).then((data)=>{
					this.oneMoreModel.submiting = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("更新成功");
						this.oneMoreModel.collectorAddr = null;
						this.oneMoreModel.meterAddr = null;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.oneMoreModel.submiting  = false;
					console.log(error);
				});
			},
			deleteNBCollector(){
				if(this.oneMoreModel.collectorAddr == null){
					this.$message.error("请输入采集器地址");
					return ;
				}
				this.oneMoreModel.submiting = true;
				let url = this.Api.getLastUrl(this.Api.COMMON_DELETE_NBCOLLECTOR_METER_URL);
				this.Api.fetchPostWithForm(url,this.oneMoreModel).then((data)=>{
					this.oneMoreModel.submiting = false;
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success("删除成功");
						this.oneMoreModel.collectorAddr = null;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.oneMoreModel.submiting  = false;
					console.log(error);
				});
			},
			configNBCollector(){
				if(this.oneMoreModel.collectorAddr == null || this.oneMoreModel.collectorAddr.length==0){
					this.$message.error("请输入采集器地址");
					return ;
				}
				this.$refs.configCollectorMeterView.showView(this.oneMoreModel.collectorAddr);
			},
			queryAllNeighborList(){
				let url = this.Api.getLastUrl(this.Api.NEIGHBOR_ALL_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let msg = data.data.message;
					let result = data.data.result;
					if(code == this.Api.HTTP_OK_CODE){
						this.neighborList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
			queryMeterKindList:function(){
				let url = this.Api.getLastUrl(this.Api.CUSTOMER_METER_KIND_LIST_URL);
				this.Api.fetchPostWithForm(url).then((data)=>{
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.meterKindList = result;
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					console.log(error);
				});
			},
	},
	created(){
		this.queryAllNeighborList();
		this.queryMeterKindList();
	},	
}
</script>

<style>
	.queryDiv{
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-bottom: 0.625rem;
	}
	.resultText {
		color: #ff9900;
		font-size: 0.8125rem;
	}
	.myInput {
		width: 2rem;
		margin-right: 0.5rem;
	}
</style>
